import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

import { visuallyHidden } from '@mui/utils';

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export type Order = 'asc' | 'desc';

export function getComparator<T extends Record<string, any>>(
  order: Order,
  orderBy: string
): (a: T, b: T) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  /** Admin-only "Owner" column, shown between the title and the trailing actions cell. */
  showOwner?: boolean;
}

export function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort, showOwner } = props;
  const { t } = useTranslation();
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell></TableCell>
        <TableCell
          align={'left'}
          padding={'normal'}
          sortDirection={orderBy === 't' ? order : false}
          size={'small'}
        >
          <TableSortLabel
            active={orderBy === 't'}
            direction={orderBy === 't' ? order : 'asc'}
            onClick={createSortHandler('t')}
          >
            Title
            {orderBy === 't' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>
        </TableCell>
        {showOwner && <TableCell>{t('common.owner')}</TableCell>}
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
}
